//import { post, put } from "axios";
import axios from 'axios';
import { getApiAsyn, baseUrl, getApiAsynarrayBuffer, deleteApi, getAuthHeaders } from "../../../PostAPI";
import { handleAPIError, APIError } from "../../../common/errorHandler";
import { API_URL } from "../../../../utils/constant";
import { extractData } from "../../../../utils";
import { getDecoratedUrl } from "../../../common/urlService";



const { post, put, get } = axios;
export const fetchRateAdminNetworks = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.RATEADMIN_NETWORKS.GET,
    payload,
  });
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result; //extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchRateAdminNetworksDropdown = async (payload) => {
  const url = API_URL.RATEADMIN_NETWORKS.DROPDOWN;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result; //extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};



export const multipartDataUploadImage = (url, payload) => {
 
  const formPayload = new FormData();
  formPayload.append("file", payload?.file[0]);
  const config = {
    headers: {
      ...getAuthHeaders(localStorage.getItem("token")),
      "Content-Type": "multipart/form-data",
    },
  };
  return post(baseUrl + url, formPayload, config);
};



export const upladImageData = async (payload) => {
  const url = API_URL.UPLOAD_IMAGE.replace(
    ":id",
    payload.id
  );
  try {
    let result = await multipartDataUploadImage(
      url,
      payload
    );

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const deleteRateAdminNetworks = async (payload) => {
  const url = API_URL.RATEADMIN_NETWORKS.DELETE
    .replace(":id", payload?.id)
    .replace(":userId", localStorage.getItem("userId"));
  try {
    let result = await deleteApi(url, localStorage.getItem("token"));
    if (result?.error) throw new APIError(result);
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

const dataUploadApi = (url, data, isEdit = false) => {
  const config = {
    headers: getAuthHeaders(localStorage.getItem("token")),
  };

  if (isEdit) {
    return post(baseUrl + url, data, config);
  } else {
    return post(baseUrl + url, data, config);
  }
};
export const createRateAdminNetworks = async (payload) => {
  try {
    let result = await dataUploadApi(
      `${API_URL.RATEADMIN_NETWORKS.CREATE}`,
      payload
    );

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const editRateAdminNetworks = async (payload) => {
  const url = API_URL.RATEADMIN_NETWORKS.EDIT.replace(":id", payload?.id);

  try {
    let result = await dataUploadApi(url, payload.data, true);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};





const dataExportApi = (url, data) => {
  const config = {
    headers: getAuthHeaders(localStorage.getItem("token")),
  };
    return get(baseUrl + url, data, config);
};

export const exportRateAdminNetworksRecord = async (payload) => {
  const url = API_URL.RATEADMIN_NETWORKS.EXPORT;
  try {
    let result = await getApiAsynarrayBuffer(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};




export const fetchRateAdminNetworksById = async (payload) => {
  const url = API_URL.RATEADMIN_NETWORKS.GET_BY_ID.replace(
    ":id",
    payload?.id
  );
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    result = extractData(result, !payload?.filters);

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const switchDefaultNetwork = async (payload) => {
  const url = `${API_URL.RATEADMIN_NETWORKS.SWITCH_DEFAULT}?networkId=${payload?.networkId}&userId=${localStorage.getItem("userId")}`;
  const config = {
    headers: {
      ...getAuthHeaders(localStorage.getItem("token")),
      Accept: "*/*",
    },
  };
  try {
    let result = await post(baseUrl + url, {}, config);

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchNetworkCredentials = async (payload) => {
  const url = API_URL.RATEADMIN_NETWORKS.GET_CREDENTIALS.replace(
    ":id",
    payload?.networkId
  );

  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    result = extractData(result, !payload?.filters);

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const updateNetworkCredentials = async (payload) => {
  const url = API_URL.RATEADMIN_NETWORKS.UPDATE_CREDENTIALS;
  const token = localStorage.getItem("token");

  const config = {
    headers: getAuthHeaders(token),
  };

  try {
    let result = await put(baseUrl + url, payload, config);

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchNetworkAuditTrail = async (payload) => {
  const url =
    `${API_URL.RATEADMIN_NETWORKS.GET_AUDIT_TRAIL}` +
    `?networkId=${payload.networkId}` +
    `&paginated=true` +
    `&page=${payload.page || 1}` +
    `&page_size=${payload.pageSize || 10}`;

  try {
    let result = await getApiAsyn(
      url,
      localStorage.getItem("token")
    );

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};